export class SurveyMessages {
  next: string;
  NextBtnText: string;
  submit: string;
  back: string;
  Continue1: string;
  SaveContinueLater: string;
  ClearAllAnswers: string;
  AsteriskMandatory: string;
  requiredInfo: string;
  SurveyTimeOutMessage: string;
  page: string;
  of1: string;
  ThankyouPage: string;
  ResponseRecorded: string;
  AnonymousHdr: string;
  MobileAnonymousHdr: string;
  StrSaveHelp: string;
  StrSaveHelpHeader: string;
  RemainingChr: string;
  ReEnterBlankMessage: string;
  PrintBlankSurvey: string;
  SurveyTimeOutWarning1: string;
  SurveyTimeOutWarning2: string;
  accessedTestMode: string;
  Rank: string;
  DropDown: string;
  AnonymousMessage: string;
  AnonymousMessageMobile: string;
  AnonymousMessageHeader: string;
  Message: string;
  QuotaExaustMsg: string;
  ParticipationQuotaExaust: string;
  AreUsureClear: string;
  TestWarningMsg: string;
  TestHeader: string;
  TestGotIt: string;
  strOk: string;
  strWarning: string;
  Search: string;
  strinvalidvaluemsg: string;
  Clear: string;
  strCookieDisable: string;
  strMonthArray: string[];
  Total: string;
  strHiddenAnswerPipingText: string;
  AcceptCookieHeader: string;
  AcceptCookieMessage: string;
  AcceptCookieButton: string;
  strManagePreference: string;
  strChooseCookies: string;
  strFuctionalCookies: string;
  strAlwaysActive: string;
  strConsentSmoothParticipation: string;
  strConsentChooseLanguage: string;
  strConsentBrowserSupport: string;
  strConsentMaintainSession: string;
  strConsentTracksStatus: string;
  strConsentRestrictedParticipation: string;
  strConsentDownloadCookie: string;
  strConsentCookie: string;
  strAnalyticsCookies: string;
  strAnalyticsCookiesGoogle: string;
  strConsentGoogleAnalytics: string;
  strAcceptCookieChoices: string;
  strCookieCancle: string;
  CurrencyNegativeValueMessage: string;
  ReenterTextMulti: string;
  Signature_SaveConfirm: string;
  Signature_Clear: string;
  Signature_ClickSave: string;
  Signature_FileSizeExeedMessage: string;
  Signature_FileTypeMessage: string;
  Signature_TapSignHere: string;
  Signature_ClickSignHere: string;
  Signature_UploadSignature: string;
  Signature_TypeHere: string;
  Participation_Nomatchfound: string;
  Participation_ChooseLanguage: string;
  RS_TypeValue: string;
  Title: string;
}

export class participationMessages {
  Error_Header: string;
  Error_Message: string;
  thankYouMessage: thankYouMessage;
  partial_and_quota_message: partialandQotaMessage;
  partial_url_message: partialUrlMessages;
  browser_message: browserMessages;
  Participation_Message_Type: number;
  isShowSubscription: boolean;
  isErrorRedirect: boolean;
  RedirectURL: string;
  addAddNoContent: boolean;
  OfflineMessage: string;
}

export class thankYouMessage {
  ThankyouPage: string;
  ReOpenkey: string;
  viralinvitepop: string;
  ViralURL: string;
  ShowBtnContinue: boolean;
  ContinueThankyouMsgInfo: string;
  CategoryScore: string;
  SurveyURL: string;
  isPrint: string;
  isThankYou: string;
  isRedirect: string;
  isBarGraph: string;
  customScript: string;
}

export class partialandQotaMessage {
  partial_header: string;
  partial_message1: string;
  partial_message2: string;
  partial_message3: string;
  PartialMessagePublicAccessDone: string;
  unique_url: string;
  unique_url1: string;
  unique_key: string;
  custom_url: string;
  button_text: string;
  isQuota: boolean;
  PrintResponseOnSaveCon: string;
}

export class partialUrlMessages {
  partially_header: string;
  partially_message: string;
  partially_last: string;
  partially_last_info: string;
  partially_begin: string;
  partially_begin_info: string;
}

export class browserMessages {
  userIp: string;
  userAgent: string;
  componentName: string;
  errorMessage: string;
  stackTrace: string;
  errorType: string;
  userUrl: string;
  ResponseUID: Number;
}
